import { createSignal } from '@verclam/pulsar';

const selectedRoleIdSignal = createSignal<number | null>(null);

export const selectRole = (roleId: number | null): void => {
	selectedRoleIdSignal.value = roleId;
};

export default selectedRoleIdSignal;
